export default function(navClass, buttonClass, backdropClass) {

    const nav = document.querySelectorAll(navClass)[0]
    const button = document.querySelectorAll(buttonClass)[0]
    const backdrop = document.querySelectorAll(backdropClass)[0]

    let isOpened = false

    const toggleClass = function(e) {
        e.preventDefault()
        e.stopPropagation()
        nav.classList.toggle('is-opened')
        isOpened = !isOpened
    }

    const open = function(e) {
        toggleClass(e)
        backdrop.addEventListener('click', dismiss)
    }

    const dismiss = function(e) {
        toggleClass(e)
        backdrop.removeEventListener('click', dismiss)
    }

    const toggleNav = function(e) {

        if ( isOpened ) {
            dismiss(e)
        } else {
            open(e)
        }

    }


    button.addEventListener('click', toggleNav)

}



// WEBPACK FOOTER //
// ./resources/assets/js/web/mobile-nav.js